// extracted by css-extract-rspack-plugin
export default {"ListItemTitle_0":"IssuePullRequestTitle-module__ListItemTitle_0__unAFRRJ","ListItemTitle_1":"IssuePullRequestTitle-module__ListItemTitle_1__RqJ9k48"};